import { useState } from 'react';

const faqs = [
  {
    q: '蜜桃视频主页怎么进入？入口在哪里？',
    a: '您可以直接在浏览器中输入蜜桃视频主页官网地址访问，也可以通过搜索引擎搜索"蜜桃视频主页"找到入口。此外，您还可以在各大应用商店搜索"蜜桃视频"下载手机客户端。',
  },
  {
    q: '蜜桃视频需要付费吗？',
    a: '蜜桃视频提供免费和付费两种观看模式。免费用户可以观看大部分内容，付费会员可享受去广告、4K超清画质、独家内容等更多权益。新用户首月会员仅需¥9.9。',
  },
  {
    q: '蜜桃视频主页有哪些功能？',
    a: '蜜桃视频主页提供八大内容分类导航、智能推荐、高清视频播放、弹幕互动、收藏分享、离线下载等功能。同时还有创作者中心、会员体系等特色功能。',
  },
  {
    q: '如何在蜜桃视频主页注册账号？',
    a: '点击蜜桃视频主页右上角的"注册"按钮，输入手机号获取验证码，设置密码后即可完成注册。您也可以使用微信扫码快速注册登录。',
  },
  {
    q: '蜜桃视频支持哪些设备观看？',
    a: '蜜桃视频支持iOS和Android手机、平板、Web网页以及智能电视等多种设备。一个账号可在多设备上使用，会员支持3台设备同时观看。',
  },
  {
    q: '蜜桃视频的内容更新频率如何？',
    a: '蜜桃视频每天更新数以万计的新内容，热门综艺和剧集同步更新。创作者也可以随时上传新作品，内容库持续丰富中。',
  },
  {
    q: '如何联系蜜桃视频客服？',
    a: '您可以拨打客服热线400-888-6666，或发送邮件至contact@mitaovideo.com。在蜜桃视频APP内也可以通过「我的-帮助与反馈」联系在线客服。',
  },
  {
    q: '忘记蜜桃视频登录密码怎么办？',
    a: '在蜜桃视频主页登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码，按照提示即可重置密码。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题解答
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于蜜桃视频主页的常见问题，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 text-lg ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 py-4 text-sm text-foreground-600 leading-relaxed bg-background-50 border-t border-background-200/70">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}